import { useRef, useState } from "react";
import { QRCodeSVG } from "qrcode.react";
import { Copy, Download, Printer, CheckCircle2 } from "lucide-react";
import { buildStoreQrLink, downloadQrPng } from "../utils/storeQr"; // adjust path

/** QR + handle + Copy / PNG / Print. Shared by the admin store list modal and the store panel page. */
export default function StoreQrCard({ storeName, handle }) {
    const wrap = useRef(null);
    const [copied, setCopied] = useState(false);

    if (!handle) {
        return <p className="p-6 text-center text-sm text-gray-500">No QR handle for this store yet. Save the store once to generate it.</p>;
    }

    const link = buildStoreQrLink(handle);

    const copyLink = async () => {
        try {
            await navigator.clipboard.writeText(link);
            setCopied(true);
            setTimeout(() => setCopied(false), 1500);
        } catch { /* clipboard blocked */ }
    };

    const btn = "flex items-center justify-center gap-1.5 rounded-lg border py-2 text-xs font-semibold text-gray-700 hover:bg-gray-50";

    return (
        <div className="text-center">
            <h2 className="text-lg font-bold text-gray-900">{storeName}</h2>
            <p className="mt-1 text-sm text-gray-500">Scan to pay at this store</p>

            <div ref={wrap} className="mx-auto mt-4 inline-block rounded-xl border p-3">
                <QRCodeSVG value={link} size={220} level="M" includeMargin />
            </div>

            <p className="mt-3 text-sm font-bold tracking-wide text-[#0B67FC]">{handle}</p>
            <p className="mt-1 break-all text-xs text-gray-400">{link}</p>

            <div className="mt-5 grid grid-cols-3 gap-2 print:hidden">
                <button onClick={copyLink} className={btn}>
                    {copied ? <CheckCircle2 size={14} className="text-emerald-600" /> : <Copy size={14} />}
                    {copied ? "Copied" : "Copy link"}
                </button>
                <button onClick={() => downloadQrPng(wrap.current?.querySelector("svg"), `${handle}.png`)} className={btn}>
                    <Download size={14} /> PNG
                </button>
                <button onClick={() => window.print()} className={btn}>
                    <Printer size={14} /> Print
                </button>
            </div>
        </div>
    );
}